import React from 'react';

interface NetworkStatusModalProps {
  isOnline: boolean;
}

const NetworkStatusModal: React.FC<NetworkStatusModalProps> = ({ isOnline }) => {
  if (isOnline) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4 animate-in fade-in slide-in-from-bottom-4 duration-300">
        <div className="flex flex-col items-center text-center">
          {/* Network Icon */}
          <div className="mb-4 relative">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
              <svg
                className="w-10 h-10 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"
                />
              </svg>
            </div>
            {/* Pulse animation */}
            <div className="absolute inset-0 w-20 h-20 bg-red-400 rounded-full animate-ping opacity-20"></div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            No Internet Connection
          </h2>

          {/* Message */}
          <p className="text-gray-600 mb-6">
            Please check your internet connection and try again. The application will automatically reconnect when your connection is restored.
          </p>

          {/* Status Indicator */}
          <div className="flex items-center space-x-2 bg-red-50 px-4 py-2 rounded-lg">
            <div className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></div>
            <span className="text-sm text-red-700 font-medium">
              Attempting to reconnect...
            </span>
          </div>

          {/* Tips */}
          <div className="mt-6 text-left w-full">
            <p className="text-xs text-gray-500 mb-2 font-semibold">Troubleshooting tips:</p>
            <ul className="text-xs text-gray-500 space-y-1">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Check your WiFi or mobile data connection</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Try toggling airplane mode on and off</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Restart your router if using WiFi</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkStatusModal;
